import { Funcionalidades } from '@/config/funcionalidades';
import Informes from "@/views/plataforma/Informes.vue";


const InformeGraficoTemperaturaRouter = [
  {
    path: '/Temperatura/dashboard',
    component: () => import('@/pantallas/InformeGraficoTemperatura/index.vue'),
    meta: {
      description: 'Informe Grafico Temperatura',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.InformeGraficoTemperatura,
    },
  },
  {
    path: '/Temperatura/generar_informe',
    component: Informes,
    meta: {
      description: 'Informes',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.InformeGraficoTemperatura,
    },
  }
];

export default InformeGraficoTemperaturaRouter;
